module.exports = [
	{
		"id": 1,
		"title": "Feedback1",
		"text": "Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus."
	},
	{
		"id": 2,
		"title": "Feedback2",
		"text": "Donec quam felis, ultricies nec, pellentesque eu, pretium quis, sem. Nulla consequat massa quis enim. Donec pede justo, fringilla vel, aliquet nec, vulputate eget, arcu."
	},
	{
		"id": 3,
		"title": "Feedback3",
		"text": "In enim justo, rhoncus ut, imperdiet a, venenatis vitae, justo. Nullam dictum felis eu pede mollis pretium. Integer tincidunt. Cras dapibus. Vivamus elementum semper nisi. Aenean vulputate eleifend tellus."
	}
];


//////////////////
// WEBPACK FOOTER
// ./src/data/feedback.json
// module id = 287
// module chunks = 0